import React from 'react';
import { IconSvgProps } from '@models/common';

const Expand: React.FC<IconSvgProps> = (props) => {
  const { size = 24, ...restProps } = props;
  return (
    <svg
      {...restProps}
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M10.5858 13.4142L7.05025 16.9497M13.4142 10.5858L16.9497 7.05025M12 18H7.06066C6.47487 18 6 17.5251 6 16.9393V12M18 12V7.06066C18 6.47487 17.5251 6 16.9393 6H12'
        stroke='currentColor'
        strokeWidth='1.6'
        strokeLinecap='round'
      />
    </svg>
  );
};

export default Expand;
